import { gql } from "@apollo/client";

export const updateProfile = gql`
  mutation UpdateProfile(
    $userId: Int!
    $email: String
    $username: String
    $role: String
    $url: String
    $desc: String
    $hours24: Boolean
    $timezone: Int
    $calendar: String
  ) {
    updateProfile(
      userId: $userId
      email: $email
      username: $username
      role: $role
      url: $url
      desc: $desc
      hours24: $hours24
      timezone: $timezone
      calendar: $calendar
    ) {
      id
      email
      username
      role
      url
      desc
      timezone
    }
  }
`;
export const addBookings = gql`
  mutation AddBooking($input: AddBookingInput) {
    addBooking(input: $input) {
      id
      eventId
      timezone
      bookingId
      time
    }
  }
`;
export const updateBookings = gql`
  mutation updateBooking($id: Int!, $status: String!) {
    updateBooking(id: $id, status: $status) {
      status
      id
    }
  }
`;
export const GET_RATING_DETAILS = gql`
  mutation getRatingDetails($ratingId: Int!) {
    getRatingDetails(ratingId: $ratingId) {
      id
      bookingId
      eventId
      name
      review
      desc
      rating
    }
  }
`;
export const getBookingAnswersBased = gql`
  mutation getBookingAnswersBased($bookingId: Int!, $questionName: String!) {
    getBookingAnswersBased(bookingId: $bookingId, questionName: $questionName) {
      id
      answer
    }
  }
`;
export const ADD_RATING = gql`
  mutation AddRating(
    $eventId: Int!
    $rating: Int!
    $bookingId: String!
    $desc: String!
    $review: String!
  ) {
    addRating(
      eventId: $eventId
      rating: $rating
      bookingId: $bookingId
      desc: $desc
      review: $review
    ) {
      eventId
      rating
      bookingId
      desc
      review
    }
  }
`;
export const GET_EVENT = gql`
  mutation getEvent($id: Int!) {
    getEvent(id: $id) {
      id
      color
      title
      companyId
    }
  }
`;
export const UPDATE_TOKEN = gql`
  mutation UpdateToken(
    $token: String!
    $hours24: Boolean!
    $username: String
    $url: String
    $timezone: Int
    $desc: String
    $role: String
    $calendar: String
  ) {
    updateToken(
      token: $token
      hours24: $hours24
      username: $username
      url: $url
      desc: $desc
      timezone: $timezone
      role: $role
      calendar: $calendar
    )
  }
`;

export const REMOVE_BOOKINGS = gql`
  mutation ($bookingId: Int!) {
    removeBooking(bookingId: $bookingId) {
      id
    }
  }
`;
export const SIGNUP_USER_GOOGLE = gql`
  mutation ($email: String!, $username: String!, $url: String!) {
    signUpGoogle(email: $email, username: $username, url: $url) {
      token
    }
  }
`;
export const UPDATE_EVENT = gql`
  mutation UpdateEvent(
    $eventId: Int!
    $groupId: Int
    $title: String
    $start: String
    $end: String
    $location: String
    $locationType: String
    $desc: String
    $color: String
    $link: String
    $length: Int
    $maxInvitees: Int
    $showRemaining: Boolean
    $eventType: String
    $eventsPerDay: Int
    $bookingOption: String
    $increments: Int
    $hidden: Boolean
    $phoneNumber: String
    $phoneNumberRadio: Boolean
    $image: Int
    $bookingApproval: Int
  ) {
    updateEvent(
      eventId: $eventId
      groupId: $groupId
      title: $title
      start: $start
      end: $end
      bookingOption: $bookingOption
      location: $location
      locationType: $locationType
      desc: $desc
      color: $color
      link: $link
      length: $length
      maxInvitees: $maxInvitees
      showRemaining: $showRemaining
      eventType: $eventType
      eventsPerDay: $eventsPerDay
      increments: $increments
      hidden: $hidden
      phoneNumber: $phoneNumber
      phoneNumberRadio: $phoneNumberRadio
      image: $image
      bookingApproval: $bookingApproval
    ) {
      id
      title
      start
      end
      location
      locationType
      desc
      color
      link
      length
    }
  }
`;
export const ADD_EVENT = gql`
  mutation AddEvent(
    $companyId: Int!
    $title: String!
    $start: String!
    $end: String!
    $location: String!
    $locationType: String!
    $desc: String!
    $color: String!
    $link: String!
    $length: Int!
    $groupId: Int!
    $maxInvitees: Int
    $showRemaining: Boolean
    $eventType: String
    $eventsPerDay: Int
    $increments: Int!
    $hidden: Boolean
    $bookingOption: String
    $phoneNumber: String
    $phoneNumberRadio: Boolean!
    $image: Int
    $bookingApproval: Int
  ) {
    addEvent(
      companyId: $companyId
      title: $title
      start: $start
      end: $end
      location: $location
      locationType: $locationType
      desc: $desc
      color: $color
      bookingOption: $bookingOption
      link: $link
      length: $length
      groupId: $groupId
      maxInvitees: $maxInvitees
      showRemaining: $showRemaining
      eventType: $eventType
      eventsPerDay: $eventsPerDay
      increments: $increments
      hidden: $hidden
      phoneNumber: $phoneNumber
      phoneNumberRadio: $phoneNumberRadio
      image: $image
      bookingApproval: $bookingApproval
    ) {
      id
      title
      start
      end
      location
      status
      locationType
      desc
      color
      link
      length
      companyId
      groupId
      maxInvitees
      showRemaining
      eventType
      increments
      eventsPerDay
      hidden
      phoneNumber
      phoneNumberRadio
    }
  }
`;
export const ADD_SUBSCRIPTION = gql`
  mutation addSubscription(
    $userId: Int!
    $role: String!
    $type: String!
    $token: String!
  ) {
    addSubscription(userId: $userId, role: $role, type: $type, token: $token)
  }
`;
export const addCompanyHourGroup = gql`
  mutation addCompanyHourGroup($input: [Company_Hour_GroupInput]!) {
    addCompanyHourGroup(input: $input) {
      id
    }
  }
`;
export const DELETE_COMPANY_HOUR = gql`
  mutation deleteCompanyHours($id: ID!) {
    deleteCompanyHours(id: $id)
  }
`;
export const ADD_COMPANY_HOUR = gql`
  mutation (
    $userId: Int!
    $groupId: Int!
    $onJob: Boolean!
    $day: String!
    $startTime: String!
    $endTime: String!
  ) {
    addCompanyHour(
      input: {
        company_hour: [
          {
            userId: $userId
            groupId: $groupId
            day: $day
            onJob: $onJob
            startTime: $startTime
            endTime: $endTime
          }
        ]
      }
      userId: $userId
      groupId: $groupId
    ) {
      id
      userId
      groupId
      day
      onJob
      startTime
      endTime
    }
  }
`;
export const LOGIN_WITH_GOOGLE = gql`
  mutation loginWithGoogle($email: String!) {
    loginWithGoogle(email: $email) {
      token
    }
  }
`;
export const REMOVE_EVENTS = gql`
  mutation ($eventId: Int!) {
    removeEvent(eventId: $eventId)
  }
`;
export const CLONE_EVENT = gql`
  mutation CloneEvent($eventId: Int!) {
    cloneEvent(eventId: $eventId)
  }
`;
export const DELETE_OVERRIDE_GROUP = gql`
  mutation deleteOverrides($id: ID!) {
    deleteOverrideGroup(id: $id)
  }
`;
export const RESET_PASSWORD = gql`
  mutation ResetPassword(
    $email: String!
    $password: String!
    $resetToken: String!
  ) {
    resetPassword(email: $email, password: $password, resetToken: $resetToken) {
      email
    }
  }
`;

export const REQUEST_RESET = gql`
  mutation RequestReset($email: String!) {
    requestReset(email: $email) {
      email
      resetToken
    }
  }
`;
export const UPDATE_COMPANY_HOUR = gql`
  mutation UpdateCompanyHour($hourId: ID!, $hourInput: Company_HourInput!) {
    updateCompanyHours(hourId: $hourId, input: $hourInput) {
      id
      day
      onJob
      startTime
      endTime
    }
  }
`;
export const UPDATE_COMPANY_HOUR_GROUP = gql`
  mutation UpdateCompanyHourGroup(
    $input: Company_Hour_GroupInput!
    $groupId: Int!
  ) {
    updateCompanyHourGroup(input: $input, groupId: $groupId) {
      id
      title
      def
    }
  }
`;
export const ADD_COMPANY_HOUR_GROUP = gql`
  mutation AddCompanyHourGroup($input: [Company_Hour_GroupInput!]!) {
    addCompanyHourGroup(input: $input) {
      id
      userId
      def
      title
    }
  }
`;
export const ADD_OVERRIDE_GROUP = gql`
  mutation ($input: newOverrideGroupInput!) {
    addOverrideGroup(input: $input) {
      id
      userId
      groupId
      date
    }
  }
`;
export const ADD_OVERRIDE = gql`
  mutation AddOverrides($overrides: [OverrideInput!]!) {
    addOverride(input: { override: $overrides }) {
      id
      userId
      groupId
      startTime
      endTime
    }
  }
`;
export const UPDATE_OVERRIDE = gql`
  mutation ($endTime: String, $startTime: String, $id: ID!) {
    updateOverride(startTime: $startTime, endTime: $endTime, id: $id) {
      id
      groupId
      startTime
      endTime
    }
  }
`;
export const DELETE_COMPANY_HOUR_GROUP = gql`
  mutation deleteCompanyHourGroup($groupId: ID!, $newDefault: ID!) {
    deleteCompanyHourGroup(groupId: $groupId, newDefault: $newDefault)
  }
`;
export const DELETE_INVITEE_QUESTION = gql`
  mutation deleteInviteeQuestion($id: ID!) {
    deleteInviteeQuestion(id: $id)
  }
`;
export const ADD_INVITEE_QUESTION = gql`
  mutation addInviteeQuestion(
    $eventId: Int!
    $questionId: Int
    $type: String!
    $title: String!
    $required: Boolean!
    $options: [String]
  ) {
    addInviteeQuestion(
      eventId: $eventId
      type: $type
      title: $title
      required: $required
      options: $options
      questionId: $questionId
    ) {
      id
      eventId
      type
      title
      required
    }
  }


`;

export const SEND_EMAIL_MUTATION = gql`
  mutation mailer($to: String!, $subject: String, $text: String, $html: String) {
    mailer(to: $to, subject: $subject, text: $text, html: $html)
  }
`;
